// extracted by mini-css-extract-plugin
export default {"WaveDivider":"WaveDivider_WaveDivider__lunip","red":"WaveDivider_red__vbIW4","yellow":"WaveDivider_yellow__wkfB7","green":"WaveDivider_green__MJ5-j"};